import { Logo } from "./Logo";
import styled, { px } from "livemap-ui";

export interface MainHeaderProps {
  title?: string;
  subTitle?: string;
}

export function MainHeader({ title, subTitle }: MainHeaderProps) {
  return (
    <Header>
      <Logo />
      <Title>{title || null}</Title>
      <SubTitle>{subTitle || null}</SubTitle>
    </Header>
  );
}

const Title = styled.h1`
  margin: ${px(36, 0, 0, 0)};
  text-align: center;
  font-size: 24px;
  font-weight: 400;

  &:empty {
    display: none;
  }
`;

const SubTitle = styled.h4`
  &:empty {
    display: none;
  }

  padding: ${px(6, 0)};
  opacity: ${p => p.theme.disabledOpacity};
  text-align: center;
  font-size: ${px(18)};
`;

const Header = styled.header`
  padding: ${px(36, 0, 6, 0)};
`;
